<template>
  <div>
    <v-container class="py-0">
      <v-row align="center" justify="start">
        <v-col
          v-for="(selection, i) in enabledFeatures"
          :key="i"
          class="shrink"
        >
          <v-chip close @click:close="removeFeature(i)" v-if="selection">
            {{ i }}
          </v-chip>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col cols="6">
          <v-select
            :items="items"
            label="Select feature"
            v-model="selectedFeature"
            solo
          ></v-select>

          <v-btn
            color="primary"
            @click="addUserFeature"
            :disabled="!selectedFeature"
            v-if="selectedFeature"
            medium
            >Add</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { usersCollection } from "@/plugins/firebase.js";

export default {
  data: () => ({
    items: [
      {
        text: "discoveryExport",
      },
      {
        text: "developerOption",
      },
      {
        text: "folders",
      },
      {
        text: "sharing",
      },
      {
        text: "translation",
      },
      {
        text: "translationDeepL",
      }
    ],
    selected: [],
    selectedFeature: null,
    enabledFeatures: {},
  }),

  computed: {},

  props: {
    featuresAlreadyEnabled: {
      default: () => {},
    },
    userId: String,
  },

  methods: {
    removeFeature(i) {
      this.enabledFeatures[i] = false;
      this.saveUserDocument(this.enabledFeatures);
    },
    addUserFeature() {
      this.enabledFeatures[this.selectedFeature] = true;
      this.saveUserDocument(this.enabledFeatures);
      this.selectedFeature = null;
    },
    async saveUserDocument(data) {
      await usersCollection
        .doc(this.userId)
        .set({ features: data }, { merge: true })
        .then(function () {
          console.log("User features were updated");
        })
        .catch(function (error) {
          console.error("Error writing document: ", error);
          this.feedback = error;
        });
    },
  },

  mounted() {
    if (this.featuresAlreadyEnabled) {
      this.enabledFeatures = this.featuresAlreadyEnabled;
    }
  },
};
</script>

<style>
</style>